import apiWrapper from 'common/api/api-wrapper';

const { REACT_APP_USER_MANAGEMENT_SERVICE_URL } = process.env;

export const resetUserActivities = async () => {
	const resp = await apiWrapper.delete<any>(
		`${REACT_APP_USER_MANAGEMENT_SERVICE_URL}/reset`,
		{},
	);
	return resp;
};
